/* created by Athukorala */

// animation ---
export const ANIMATION = "ANIMATION";
// spinner
export const SPINNER = "SPINNER";
// history handler
export const BROUSER_HISTORY = "BROUSER_HISTORY";

// user handler
export const USER = "USER";

// reception meeting shedule handler
export const CUSTOM_VISITORS = "CUSTOM_VISITORS";
export const ALL_BUILDINGS = "ALL_BUILDINGS";
export const ALL_WIFI_PACKAGES = "ALL_WIFI_PACKAGES";
export const ALL_FLOORS = "ALL_FLOORS";
export const ALL_AVAILABLE_CARDS = "ALL_AVAILABLE_CARDS";

// reception visitor count & graph
export const VISITOR_COUNT_LIST = "VISITOR_COUNT_LIST";
export const VISITOR_COUNT_LIST_GRAPH = "VISITOR_COUNT_LIST_GRAPH";
export const VISITOR_TIMES_LIST_GRAPH = "VISITOR_TIMES_LIST_GRAPH";

// reception view all check INs and checkout
export const GET_ALL_VISITORS = "GET_ALL_VISITORS";

// Socket
export const SOCKET_SELECT_BRANCH_VISITOR = "SOCKET_SELECT_BRANCH_VISITOR";
export const SOCKET_FETCH_ALL_BRANCH_VISITORS = "SOCKET_FETCH_ALL_BRANCH_VISITORS";
export const SOCKET_ADD_NEW_BRANCH_VISITOR = "SOCKET_ADD_NEW_BRANCH_VISITOR";
export const SOCKET_BRANCH_ID = "SOCKET_BRANCH_ID";
export const SOCKET_DELETE_BRANCH_VISITOR = "SOCKET_DELETE_BRANCH_VISITOR";
export const SOCKET_DELETE_VISITORS_ID_LIST = "SOCKET_DELETE_VISITORS_ID_LIST";

// image handler
export const IMAGE_UPLOADER = "IMAGE_UPLOADER";

// file handler
export const FILE_UPLOADER = "FILE_UPLOADER";

/**
 * Corporate Admin actions types
 */
export const ADD_FLOOR = "ADD_FLOOR";
export const GET_FLOOR = "GET_FLOOR";
export const GET_ALL_LOCATIONS = "GET_ALL_LOCATIONS";
export const GET_ALL_CORPORATE_USERS = "GET_ALL_CORPORATE_USERS";
export const ADD_BRANCH = "ADD_BRANCH";
export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const ADD_RECEPTION = "ADD_RECEPTION";
export const ADD_WIFIPACKAGE = "ADD_WIFIPACKAGE";
export const ADD_TAGS_DASHBOARD = "ADD_TAGS_DASHBOARD";
export const ADD_TAGS_DASHBOARD_SINGLE = "ADD_TAGS_DASHBOARD_SINGLE";

/**
 * Super Admin actions types
 */

export const SYSTEM_CHANGER = "SYSTEM_CHANGER";
export const GET_ALL_CORPORATES = "GET_ALL_CORPORATES";

/**
 * Event
 * Coporate admin event actions types
 */

export const ADD_EVENT_ORGANIZER = "ADD_EVENT_ORGANIZER";
export const ADD_EVENT_PUBLIC_SPEAKER = "ADD_EVENT_PUBLIC_SPEAKER"
//-------------[Event handler]-------------

export const ALL_EVENT_CATOGARIES = "ALL_EVENT_CATOGARIES";
export const EVENT_PARTICIPANT_QUESTION = "EVENT_PARTICIPANT_QUESTION";
export const EVENT_PARTICIPANT_QUESTION_UPDATE_TIME = "EVENT_PARTICIPANT_QUESTION_UPDATE_TIME";

// --------[Temp Store Main Details]-------

export const STORE_EVENT_DETAILS = "STORE_EVENT_DETAILS";
export const STORE_SUB_EVENT_DETAILS = "STORE_SUB_EVENT_DETAILS";
export const CHANGE_CREATE_EVENT_STEP = "CHANGE_CREATE_EVENT_STEP";
export const DELETE_SUB_EVENT = "DELETE_SUB_EVENT";
export const UPDATE_SUB_EVENT = "UPDATE_SUB_EVENT";
export const CHANGE_HAS_SUB_EVENTS = "CHANGE_HAS_SUB_EVENTS";
export const CHANGE_ACTIVATION_OF_STEP = "CHANGE_ACTIVATION_OF_STEP";
export const ADD_AGENDA = "ADD_AGENDA";

export const File_UPLOADER = "File_UPLOADER";

//host handle
export const STORE_HOST_MOBILE = "STORE_HOST_MOBILE";
export const REMOVE_HOST_MOBILE = "REMOVE_HOST_MOBILE";
export const STORE_HOST_ENTITY = "STORE_HOST_ENTITY";
export const REMOVE_HOST_ENTITY = "REMOVE_HOST_ENTITY";
export const SET_HOST_CURRENT_MEETING = "SET_HOST_CURRENT_MEETING";
export const REMOVE_HOST_CURRENT_MEETING = "REMOVE_HOST_CURRENT_MEETING";

// handle redux for events
export const SET_CURRENT_EVENT_DATA = "SET_CURRENT_EVENT_DATA";
export const REMOVE_CURRENT_EVENT_FROM_REDUX = "REMOVE_CURRENT_EVENT_FROM_REDUX";
export const SET_CURRENT_SUB_EVENTS_DATA = "SET_CURRENT_SUB_EVENTS_DATA"; // this one use to set current event all sub events
export const SET_CURRENT_SUB_EVENT = "SET_CURRENT_SUB_EVENT"; // this one use to set current sub event id

//participant handle

export const DISPLAY_APPROVE_PARTICIPANT = "DISPLAY_APPROVE_PARTICIPANT";
export const DECLINE_PARTICIPANT = "DECLINE_PARTICICPANT";

//question handle

export const QUESTION_HANDLER = "QUESTION_HANDLER";

// guest user handler
export const GUEST_USER_VALIDATION = "GUEST_USER_VALIDATION";
export const GUEST_BRANCH_NAME = "GUEST_BRANCH_NAME";
export const GUEST_QR_HR_COVID_RESULT = "GUEST_QR_HR_COVID_RESULT";
export const GUEST_CURRENT_CORPORATE_ID = "GUEST_CURRENT_CORPORATE_ID";



// user groups handler
export const SAVE_USER_GROUP_DETAILS = "SAVE_USER_GROUP_DETAILS";

// spacetags workspace handler
export const SAVE_WORKSPACE = "SAVE_WORKSPACE";
export const REMOVE_WORKSPACE = "REMOVE_WORKSPACE";
export const SAVE_RESERVATION_DATA = "SAVE_RESERVATION_DATA";
export const REMOVE_RESERVATION_DATA = "REMOVE_RESERVATION_DATA";
export const STORE_RESERVATION_DATE = "STORE_RESERVATION_DATE";


// email modal handler
export const EVENT_MODAL_VISIBLE = "EVENT_MODAL_VISIBLE";
export const EVENT_MODAL_DATA = "EVENT_MODAL_DATA";
